import { graphql } from '@apollo/client/react/hoc';
import { DocumentNode } from 'graphql';

const formTemporaryMutation = (mutation: DocumentNode | undefined) => {
  if (!mutation) return null;

  return graphql(mutation, {
    name: 'formTemporaryUpdate',
    options: {
      fetchPolicy: 'no-cache',
    },
  });
};

export default formTemporaryMutation;
